import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between min-h-screen" }
const _hoisted_2 = { class: "relative" }

import { ColorName, INotification } from '@/lib';
import { BaseFooter } from '@/lib/components/Footer';
import { LoadingBar } from '@/lib/components/Loading';
import { NotificationStack } from '@/lib/components/Notification';
import { MainNavigation, NavLink } from '@/lib/components/Navigation';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useProgressStore } from '@/stores/progress.store';
import { useNotificationStore } from '@/stores/notification.store';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const progressStore = useProgressStore();
const notificationStore = useNotificationStore();
const nav = ref(null);
const top = ref(0);
const notifications: INotification[] = computed(() => notificationStore.notifications);
const loading: number = computed(() => progressStore.progress);
const color: ColorName = computed(() => progressStore.color);
const isConsultListDisabled: boolean = computed(() => process.env.VUE_APP_DISABLE_CONSULT_LIST_TEMP?.toLowerCase() === 'true');

const onScroll = () => {
  const rect = nav.value?.$el?.getBoundingClientRect();
  if (rect) {
    if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
      top.value = rect.height;
    } else {
      top.value = 0;
    }
  }
};

const onNotificationsUpdate = (notifications: INotification[]) => {
  notificationStore.notifications = notifications;
};

onMounted(() => {
  top.value = nav.value.$el.clientHeight;
  window.addEventListener('scroll', () => onScroll());
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', () => onScroll());
});

return (_ctx: any,_cache: any) => {
  const _directive_allow = _resolveDirective("allow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_unref(MainNavigation), {
        ref_key: "nav",
        ref: nav,
        "data-cy": "main-navigation"
      }, {
        nav: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_unref(NavLink), { to: "/participants" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('platform.navigation.participants')), 1)
            ]),
            _: 1
          })), [
            [_directive_allow, 'anonymous-participant:read']
          ]),
          _withDirectives((_openBlock(), _createBlock(_unref(NavLink), { to: "/patients" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('platform.navigation.patients')), 1)
            ]),
            _: 1
          })), [
            [_directive_allow, 'patient:read']
          ]),
          (!_unref(isConsultListDisabled))
            ? _withDirectives((_openBlock(), _createBlock(_unref(NavLink), {
                key: 0,
                to: "/consults"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('platform.navigation.consults')), 1)
                ]),
                _: 1
              })), [
                [_directive_allow, 'consult:read']
              ])
            : _createCommentVNode("", true),
          _withDirectives((_openBlock(), _createBlock(_unref(NavLink), { to: "/worklists" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('platform.navigation.worklists')), 1)
            ]),
            _: 1
          })), [
            [_directive_allow, 'consult:schedule']
          ]),
          _withDirectives((_openBlock(), _createBlock(_unref(NavLink), { to: "/reviews" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('platform.navigation.reviews')), 1)
            ]),
            _: 1
          })), [
            [_directive_allow, 'review:read']
          ]),
          _withDirectives((_openBlock(), _createBlock(_unref(NavLink), { to: "/virtual-ward" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('custom.uhb.copd.virtual-ward')), 1)
            ]),
            _: 1
          })), [
            [_directive_allow, 'copd-home-monitoring:program:read']
          ])
        ]),
        _: 1
      }, 512),
      _createVNode(_unref(LoadingBar), {
        value: _unref(loading),
        color: _unref(color)
      }, null, 8, ["value", "color"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(NotificationStack), {
          class: "mt-6 mr-6 z-40",
          style: _normalizeStyle('top:' + top.value + 'px;'),
          "display-items": 6,
          "model-value": _unref(notifications),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (onNotificationsUpdate($event)))
        }, null, 8, ["style", "model-value"])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(_unref(BaseFooter))
  ]))
}
}

})